export default {
  common: {
    tcApi: 'https://tc-service.gb.nsoftcdn.com/v2/b2b/translations',
    assetsApi: 'https://assets-api.nsoft.io',
    assetsStorage: 'https://eu-central-1.linodeobjects.com/nsoft-assets/',
    streamMappingApi: 'https://games-stream-mapping.7platform.net',
    streamMappingPath: '/.netlify/functions/getStreamUuid',
    localAdmin: 'http://127.0.0.1',
    paths: {
      localPubSubSocket: ':8070',
      localPubSubPublish: ':8071/publish',
    },
  },
  development: {
    ngsEndpoint: 'https://ngs-staging.7platform.com',
    platformApi: 'https://services-staging.7platform.com',
    gcmApi: [
      'https://gcm-fra-staging-1.7platform.com:8008', //
      'https://gcm-fra-staging-2.7platform.com:8008',
    ],
    streamHost: '://stream-staging.7platform.live',
    ajsApi: 'https://ngs-ajs-staging.nsoft.com',
    cmsApi: 'https://staging-gravity-service.7platform.com/v1/',
  },
  staging: {
    ngsEndpoint: 'https://ngs-staging.7platform.com',
    platformApi: 'https://services-staging.7platform.com',
    gcmApi: [
      'https://gcm-fra-staging-1.7platform.com:8008', //
      'https://gcm-fra-staging-2.7platform.com:8008',
    ],
    streamHost: '://stream-staging.7platform.live',
    ajsApi: 'https://ngs-ajs-staging.nsoft.com',
    cmsApi: 'https://staging-gravity-service.7platform.com/v1/',
  },
  production: {
    ngsEndpoint: 'https://games.gb.nsoftcdn.com',
    platformApi: 'https://menhir.gb.nsoftcdn.com',
    gcmApi: [
      'https://gcm-1.de.nsoftcdn.com:8443', //
      'https://gcm-2.de.nsoftcdn.com:8443',
      'https://gcm-3.de.nsoftcdn.com:8443',
    ],
    streamHost: '://stream.7platform.live',
    ajsApi: 'https://games-ajs.gb.nsoftcdn.com',
    cmsApi: 'https://gravity.de.nsoftcdn.com/v1/',

    dcSpecific: {
      rs: {},
      rs2: {},
      ro: {
        ngsEndpoint: 'https://games.ro.nsoftcdn.com',
      },
      ro2: {
        ngsEndpoint: 'https://games.ro.nsoftcdn.com',
      },
      de: {
        ngsEndpoint: 'https://games.de.nsoftcdn.com',
      }
    },
  },
};
